<template>
  <div class="result-page" :class="{ 'result-page--no-download': !showDownload }">
    <section class="result-hero">
      <div class="result-hero-glow"></div>
      <p class="result-hero-label">申请进度</p>
      <h1 class="result-hero-title"><span class="result-clock">◷</span>提交成功，申请受理中</h1>
      <p class="result-hero-subtitle">
        您的申请已提交，{{
          showDownload ? '请下载官方App查看申请受理结果' : '请耐心等待申请受理结果'
        }}
      </p>
    </section>

    <div v-if="loading" class="result-loading">正在获取申请结果...</div>

    <template v-else>
      <h2 class="section-heading">关于我们</h2>
      <section class="about-card">
        <div class="about-brand">
          <span class="about-logo-icon" aria-hidden="true">
            <img class="about-logo" src="../../assets/images/sjh_logo.png" alt="" />
          </span>
          <strong class="about-brand-name">闪借花</strong>
        </div>
        <p class="about-institution">鹰潭高新技术产业园区汇鑫小额贷款股份有限公司</p>
        <div class="about-divider"></div>
        <div class="about-row"><span>可借金额(元)</span><strong>1,000～200,000</strong></div>
        <!-- 关于我们展示约定的利率区间，具体产品仍以实际审批和签约前明示为准。 -->
        <div class="about-row about-row--rate">
          <span>年化利率(单利，已包含全部息费)</span><strong>7.2%～24%</strong>
        </div>
        <div class="about-row"><span>支持期限</span><strong>1～12期</strong></div>
        <p class="about-footnote">具体额度、利率及期限以实际审批和签约前明示为准</p>
      </section>

      <p class="safety-note">
        <!-- 按结果页安全提醒口径补充海外客服识别提示。 -->
        本平台不会以任何名义向您收取费用，也不会要求您进行转账、提供银行卡密码或缴纳保证金。机构也不会使用海外客服。请您注意识别，谨防仿冒诈骗行为。
      </p>

      <section v-if="showLoanSuper" class="products-section">
        <div class="section-heading section-heading-row">
          <h2>第三方金融机构</h2>
          <button v-if="showMore" type="button" class="more-link" @click="handleMore">
            查看更多 <span>›</span>
          </button>
        </div>
        <p class="products-caption">以下是第三方金融机构产品，请根据自身贷款需求，合理申请</p>

        <article v-for="item in productList" :key="item.productId" class="product-card">
          <span class="product-ad">广告</span>
          <div class="product-main">
            <img class="product-logo" :src="item.imgUrl" alt="" />
            <div class="product-title">
              <h3>{{ item.productName }}</h3>
              <p v-if="item.organizationName">{{ item.organizationName }}</p>
            </div>
          </div>
          <div class="product-detail">
            <div class="product-metric">
              <span>最高可借(元)</span>
              <strong class="product-amount">{{ item.maxAmount || '--' }}</strong>
            </div>
            <div class="product-metric product-metric--rate">
              <span>综合年化利率(单利)</span>
              <strong class="product-rate">{{ item.displayRate }}</strong>
            </div>
            <button type="button" class="product-apply" @click="handleProductClick(item)">
              立即申请
            </button>
          </div>
          <p class="product-footnote">已包含全部息费，具体以实际审批为准</p>
          <div
            v-if="item.organizationName || item.organizationPhone || item.officialWebsite"
            class="product-service"
          >
            <p v-if="item.organizationName">
              本服务由<span class="product-service-company">【{{ item.organizationName }}】</span
              >提供，授信与放款由持牌金融机构完成，年化利率以实际审批为准。
            </p>
            <p v-if="item.organizationPhone">客服电话：{{ item.organizationPhone }}</p>
            <p v-if="item.officialWebsite">官方网站：{{ item.officialWebsite }}</p>
          </div>
        </article>
      </section>
    </template>

    <footer v-if="showDownload" class="download-dock">
      <button type="button" class="download-button" @click="handleDownload">下载闪借花APP</button>
    </footer>

    <SharePop :show="showSharePop" @change="showSharePop = $event" />
  </div>
</template>

<script>
import * as API_Common from '@/api/common.js'
import { formatAppFrameLinkUrl } from '@/utils/appFrameUrl.js'

const PRODUCT_LIST_BY_SOURCE = {
  renpinjiekuan: 'productListTl3.html',
  huiyihua: 'productListSjh.html',
  yangxiaomie: 'productListCchjq.html',
  sjhreview: 'productListSjh2.html',
}

export default {
  name: 'Apply930Result',
  data() {
    return {
      source: this.$route.query.source || '',
      loading: true,
      showLoanSuper: false,
      showMore: false,
      showDownload: false,
      productList: [],
      downAppUrl: '',
      showSharePop: false,
    }
  },
  created() {
    // 结果内容和展示开关必须来自同一渠道配置，避免与首页贷超配置串用。
    this.loadResult()
  },
  methods: {
    enabled(value) {
      return value === true || value === 1 || value === '1'
    },
    normalizeRate(value, fallback) {
      const rate = value == null || value === '' ? fallback : String(value)
      return rate.endsWith('%') ? rate : `${rate}%`
    },
    async loadResult() {
      try {
        const res = await API_Common.resultLoanSuperList({ channelCode: this.source })
        if (res?.code !== 200 || !res.data) {
          throw new Error(res?.msg || '结果接口无数据')
        }
        const data = res.data
        const showLoanSuper = this.enabled(data.resultLoanSuperEnable)
        const products = showLoanSuper && Array.isArray(data.products) ? data.products : []
        const configuredCount = data.resultLoanSuperCount
        const count =
          configuredCount == null ? products.length : Math.max(0, Number(configuredCount) || 0)

        this.productList = products.slice(0, count).map((item) => {
          const organizationName = String(item.organizationName || '').trim()
          return {
            ...item,
            // 数字是接口占位值而非机构名称，不展示在产品标题下方。
            organizationName: /^\d+$/.test(organizationName) ? '' : organizationName,
            // 联系方式只展示接口实际返回的非空值，避免卡片出现空白标签行。
            organizationPhone: String(item.organizationPhone || '').trim(),
            officialWebsite: String(item.officialWebsite || '').trim(),
            displayRate: `${this.normalizeRate(item.minLoanRate, '--')}～${this.normalizeRate(
              item.maxLoanRate,
              '24'
            )}`,
          }
        })
        this.showLoanSuper = showLoanSuper
        this.showMore = this.enabled(data.resultLoanSuperListEnable)
        this.showDownload = this.enabled(data.h5DownloadPageShow)
        if (this.showDownload) this.loadDownloadUrl()
      } catch (error) {
        console.error('获取930结果页数据失败', error)
        this.$toast.fail('获取申请结果失败，请重试')
      } finally {
        this.loading = false
      }
    },
    async loadDownloadUrl() {
      try {
        const res = await API_Common.getDownloadUrl(this.source, true, false)
        if (res?.code === 200 && res.data?.url) this.downAppUrl = res.data.url
      } catch (error) {
        console.error('获取930下载地址失败', error)
      }
    },
    handleDownload() {
      if (!this.downAppUrl) {
        this.$toast('下载地址获取中，请稍候')
        this.loadDownloadUrl()
        return
      }
      // 微信内无法稳定直接拉起下载，沿用 H5 既有的浏览器打开提示。
      if (this.isWeixin()) {
        this.showSharePop = true
        return
      }
      window.location.href = this.downAppUrl
    },
    handleMore() {
      const page = PRODUCT_LIST_BY_SOURCE[this.source] || 'productListOrange.html'
      window.location.href = `/${page}?source=${encodeURIComponent(this.source)}&tsp=${Date.now()}`
    },
    handleProductClick(item) {
      // 需要站内校验/授权的产品交给既有详情页处理，其余产品实时校验后直接跳转。
      if (Number(item.checkMobileStatus) !== 0 || Number(item.isShowAgreement) === 1) {
        window.location.href = `/productDetail?productId=${encodeURIComponent(
          item.productId
        )}&showPage=26&source=${encodeURIComponent(this.source)}`
        return
      }
      API_Common.buried({ productId: item.productId, showPage: 26 })
        .then((res) => {
          const productId = res.data.productId || item.productId
          window.location.href = `/appFrame?productId=${encodeURIComponent(
            productId
          )}&url=${formatAppFrameLinkUrl(res.data.linkUrl)}`
        })
        .catch((error) => {
          console.error('930产品实时校验失败', error)
          this.$toast.fail(error.message || '获取跳转链接失败')
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.result-page {
  box-sizing: border-box;
  min-height: 100vh;
  padding: 0.28rem 0.28rem calc(1.6rem + env(safe-area-inset-bottom));
  color: #30343b;
  background: #f5f6f8;
}

.result-page--no-download {
  padding-bottom: calc(0.28rem + env(safe-area-inset-bottom));
}

.result-hero {
  position: relative;
  overflow: hidden;
  padding: 0.42rem 0.36rem 0.46rem;
  color: #fff;
  background: linear-gradient(125deg, #ff8c56, #ff6633 72%);
  border-radius: 0.28rem;
  box-shadow: 0 0.16rem 0.36rem rgba(255, 106, 52, 0.18);
}

.result-hero-glow {
  position: absolute;
  top: -1.1rem;
  right: -0.9rem;
  width: 3.4rem;
  height: 3.4rem;
  border: 0.02rem solid rgba(255, 255, 255, 0.25);
  border-radius: 50%;
}

.result-hero-label {
  margin-bottom: 0.16rem;
  font-size: 0.24rem;
  opacity: 0.86;
}

.result-hero-title {
  font-size: 0.36rem;
  font-weight: 700;
  line-height: 1.4;
}

.result-clock {
  margin-right: 0.12rem;
  font-size: 0.42rem;
}

.result-hero-subtitle {
  margin-top: 0.12rem;
  font-size: 0.24rem;
  line-height: 1.55;
  opacity: 0.93;
}

.result-loading {
  // 加载态没有卡片文字继承链，单独限定字号，避免移动端根字号放大提示文案。
  padding: 0.48rem 0;
  color: #7f8792;
  font-size: 0.28rem;
  line-height: 1.5;
  text-align: center;
}

.section-heading {
  margin: 0.28rem 0.06rem 0.14rem;
  font-size: 0.32rem;
  font-weight: 700;
}

.section-heading-row {
  display: flex;
  align-items: center;
  justify-content: space-between;

  h2 {
    font-size: inherit;
  }
}

.more-link {
  padding: 0;
  color: #666;
  font-size: 0.24rem;
  background: none;
  border: 0;

  span {
    color: #ff6b35;
    font-size: 0.34rem;
  }
}

.about-card,
.product-card {
  background: #fff;
  border: 0.01rem solid #eceef1;
  border-radius: 0.24rem;
  box-shadow: 0 0.05rem 0.18rem rgba(25, 31, 41, 0.035);
}

.about-card {
  // 关于我们保留完整披露内容，用更紧凑的留白降低首屏占高。
  padding: 0.24rem;
}

.about-brand {
  display: flex;
  align-items: center;
  gap: 0.16rem;
}

.about-logo-icon {
  position: relative;
  display: block;
  flex: 0 0 0.72rem;
  width: 0.72rem;
  height: 0.72rem;
  overflow: hidden;
  border-radius: 0.18rem;
}

.about-logo {
  // 原图下方自带文字，放大并裁出上半部图标，避免与右侧标题重复。
  position: absolute;
  top: 0;
  left: 50%;
  width: 130%;
  max-width: none;
  transform: translateX(-50%);
}

.about-brand-name {
  color: #252b33;
  font-size: 0.3rem;
  font-weight: 700;
  letter-spacing: 0.01em;
}

.about-institution {
  margin: 0.14rem 0.04rem 0;
  color: #59616e;
  font-size: 0.22rem;
  font-weight: 500;
  line-height: 1.35;
  text-align: center;
}

.about-divider {
  height: 0.01rem;
  margin: 0.18rem 0 0.08rem;
  background: #f0f1f3;
}

.about-row {
  display: flex;
  gap: 0.16rem;
  align-items: flex-start;
  justify-content: space-between;
  padding: 0.09rem 0;
  color: #69717d;
  font-size: 0.23rem;

  span {
    max-width: 58%;
  }

  strong {
    color: #30343b;
    font-weight: 600;
    text-align: right;
  }
}

.about-row--rate {
  // 合规利率标签完整显示在一行，字号单独缩小避免挤压右侧区间。
  gap: 0.08rem;
  font-size: 0.2rem;
  white-space: nowrap;

  span {
    max-width: none;
  }
}

.about-footnote,
.product-footnote {
  margin-top: 0.12rem;
  color: #a0a5ad;
  font-size: 0.21rem;
  line-height: 1.5;
}

.about-footnote {
  margin-top: 0.08rem;
  font-size: 0.19rem;
}

.safety-note {
  margin: 0.22rem 0.04rem 0;
  padding: 0.2rem 0.24rem;
  color: #777d84;
  font-size: 0.22rem;
  line-height: 1.6;
  background: #fff9f4;
  border-left: 0.05rem solid #ffb285;
  border-radius: 0.06rem 0.14rem 0.14rem 0.06rem;
}

.products-caption {
  margin: -0.04rem 0.06rem 0.2rem;
  color: #7f8792;
  font-size: 0.23rem;
  line-height: 1.5;
}

.product-card {
  position: relative;
  overflow: hidden;
  margin-bottom: 0.18rem;
  padding: 0.28rem;
}

.product-ad {
  position: absolute;
  top: 0.22rem;
  right: 0.24rem;
  color: #aab0b7;
  font-size: 0.2rem;
}

.product-main {
  display: flex;
  gap: 0.18rem;
  align-items: center;
  padding-right: 0.58rem;
}

.product-logo {
  flex-shrink: 0;
  width: 0.76rem;
  height: 0.76rem;
  object-fit: contain;
  border-radius: 0.12rem;
}

.product-title {
  min-width: 0;

  h3 {
    color: #222934;
    font-size: 0.28rem;
    font-weight: 700;
  }

  p {
    overflow: hidden;
    margin-top: 0.05rem;
    color: #7f8792;
    font-size: 0.21rem;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.product-detail {
  display: flex;
  gap: 0.12rem;
  align-items: flex-end;
  // 产品名称与额度信息属于同一张卡片，缩短留白让信息更连贯。
  margin-top: 0.1rem;
}

.product-metric {
  flex: 1;
  min-width: 0;

  > span {
    // 标签独立成行，避免继承页面基础字号撑出多余的匿名行盒。
    display: block;
    color: #7f8792;
    font-size: 0.21rem;
  }

  strong {
    display: block;
    margin-top: 0.12rem;
    color: #252b33;
    font-weight: 700;
    white-space: nowrap;
  }
}

.product-metric--rate {
  flex: 1.25;
}

.product-amount {
  font-size: 0.38rem;
  line-height: 1.1;
}

.product-rate {
  font-size: 0.26rem;
}

.product-apply {
  flex-shrink: 0;
  margin-bottom: 0.02rem;
  padding: 0.18rem 0.22rem;
  color: #fff;
  font-size: 0.23rem;
  font-weight: 600;
  background: #ff6b35;
  border: 0;
  border-radius: 0.48rem;
}

.product-footnote {
  margin-top: 0.18rem;
  font-size: 0.2rem;
}

.product-service {
  margin-top: 0.12rem;
  color: #69717d;
  font-size: 0.2rem;
  line-height: 1.5;
  overflow-wrap: anywhere;

  p + p {
    margin-top: 0.04rem;
  }
}

.product-service-company {
  color: #f45b42;
}

.download-dock {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 20;
  padding: 0.16rem 0.32rem calc(0.16rem + env(safe-area-inset-bottom));
  background: #fff;
  box-shadow: 0 -0.04rem 0.2rem rgba(0, 0, 0, 0.04);
}

.download-button {
  width: 100%;
  height: 0.92rem;
  color: #fff;
  font-size: 0.32rem;
  font-weight: 600;
  background: linear-gradient(90deg, #ff8a4a 0%, #ff5612 100%);
  border: 0;
  border-radius: 0.46rem;
  box-shadow: 0 0.12rem 0.28rem rgba(255, 86, 18, 0.32);
}
</style>
